import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (password.length < 6) return toast.error("Minimum 6 caractères");
    if (password !== confirm) return toast.error("Les mots de passe ne correspondent pas");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Mot de passe modifié — connectez-vous.");
      navigate("/login");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-bg flex items-center justify-center p-6">
      <div className="w-full max-w-md page-enter">
        <Link to="/" className="flex items-center gap-2 justify-center mb-8">
          <div className="w-10 h-10 rounded-xl bg-primary-c flex items-center justify-center text-white font-display text-lg">O</div>
          <span className="font-display text-2xl">Oresto</span>
        </Link>
        <div className="card-c">
          <h1 className="font-display text-3xl">Nouveau <span className="font-serif-italic text-primary-c">mot de passe.</span></h1>
          {!token ? (
            <p className="text-red-600 text-sm mt-4">Lien invalide. Redemandez un email de réinitialisation.</p>
          ) : (
            <form onSubmit={onSubmit} className="mt-6 space-y-4">
              <div>
                <label className="text-sm font-medium text-text-secondary block mb-2">Nouveau mot de passe</label>
                <input data-testid="reset-password-input" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} className="input-c" placeholder="Au moins 6 caractères" />
              </div>
              <div>
                <label className="text-sm font-medium text-text-secondary block mb-2">Confirmer</label>
                <input data-testid="reset-confirm-input" type="password" required minLength={6} value={confirm} onChange={(e) => setConfirm(e.target.value)} className="input-c" placeholder="Répétez le mot de passe" />
              </div>
              <button data-testid="reset-submit-button" disabled={loading} className="btn-primary w-full">
                {loading ? "Modification…" : "Modifier le mot de passe"}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
